import { useState, useEffect } from 'react';
import { authenticationService } from '../services/authenticationService';

/**
 * Custom hook to subscribe to the current authenticated user
 * Manages the subscription lifecycle and provides access to current user state
 *
 * @returns {[Object|null, Function]} Tuple containing [currentUser, setCurrentUser]
 *
 * @example
 * const [currentUser, setCurrentUser] = useCurrentUser();
 */
export const useCurrentUser = () => {
    const [currentUser, setCurrentUser] = useState(() => authenticationService.currentUserValue);

    useEffect(() => {
        const subscription = authenticationService.currentUser.subscribe(user => {
            setCurrentUser(user);
        });

        return () => subscription.unsubscribe();
    }, []);

    return [currentUser, setCurrentUser];
};
